module.exports = __webpack_public_path__ + "assets/922efb10e65362f2c57501850cd6676f.mp3";